import React from 'react';

const Footer = ({ onShowPrivacyPolicy }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-columns">
        <div className="footer-col">
          <h4>Contact Us</h4>
          <p><strong>Phone:</strong> <a href="tel:+19719985516">(971)-998-5516</a></p>
          <p><strong>Email:</strong> <a href="mailto:hr@dhriti.solutions">hr@dhriti.solutions</a></p>
          <p><strong>Hours:</strong> Mon-Fri, 9:00 AM - 5:00 PM EST</p>
        </div>

        <div className="footer-col">
          <h4>Our Office</h4>
          <p><strong>Albany (HQ) & Human Resources</strong></p>
          <p>20 Sutton Dr, Cohoes, NY 12047</p>
        </div>

        <div className="footer-col">
          <h4>Company</h4>
          <ul>
            <li><a href="#about">About Us</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Legal</h4>
          <ul>
            <li>
              <button type="button" onClick={onShowPrivacyPolicy}>
                Privacy Policy
              </button>
            </li>
            <li><span className="footer-muted-link">Terms of Service</span></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {currentYear} Dhriti Solutions Inc. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
